<template>
  <div class="tooltip2" ref="tooltip2">
    <div>
      <a class="fa fa-times tooltip2__close2" @click="hide"></a>
    </div>
    <div class="tooltip2__content2">
      <slot></slot>
    </div>

  </div>
</template>

<script>
export default {
  methods: {
    hide() {
      this.$refs.tooltip2.style.visibility = 'hidden';
    },
  },
};
</script>

<style lang="scss">
@import '~styles/app.scss';
@import '~styles/variables.scss';
@import '~styles/_mixins.scss';
@import '~styles/_animations.scss';

.tooltip2 {
  font-size: 14px;
  @include shadow(2);
  position: absolute;
  align-items: center;
  white-space: nowrap;
  color: var(--white);
  background-color: var(--white);
  border-radius: 3px;
  visibility: visible;
  z-index: 999;
  animation: subtleJumpInOut 225ms ease-in-out;
  margin: 20px -300px;
  padding: 5px;
  min-height: 26px;
  line-height: 20px;

  @media screen and (max-width: 760px) {
    margin: 28px 0;
  }

  &__content2 {
    overflow: hidden;
    padding: 5px 10px 15px;
    position: relative;
    color: black;
    text-align: left;
  }

  &__close2 {
    color: var(--brand-orange);
    cursor: pointer;
    height: 16px;
    font-size: 20px;
    width: 100%;
    text-align: right;
    &:hover {
    }
    @media screen and (max-width: 760px) {
      font-size: 28px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/Tooltip2.vue